var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"block-explorer",on:{"click":_vm.click}},[_c('i',{staticClass:"fa fa-link fa-lg"}),_vm._v(" View on Block Explorer ")])}
var staticRenderFns = []

export { render, staticRenderFns }